import React, {Component,useState} from 'react';


import PropTypes from 'prop-types';


import {Form, Button, Modal, Container, Row, Col, Card, Accordion, AccordionCollapse, AccordionToggle} from 'react-bootstrap';


import NavPanel from './NavPanel';
import {MdHelp, MdInfo} from "react-icons/md";

import _ from 'lodash';

const NewAssessmentPropTypes = {

    progress: PropTypes.number,
    postMountCallback: PropTypes.func,

    assessmentInfo: PropTypes.object.isRequired,
}




class NewAssessment extends Component {

    constructor(props) {
        super(props);


        this.state = {
            // selected:this.props.selectedItems ? this.props.selectedItems : [],
            assessmentInfo:this.props.assessmentInfo ? this.props.assessmentInfo : {},
        }

    }



    // componentDidMount() {
    componentDidMount = async () => {
        console.log("componentDidMount");

        if(this.props.postMountCallback)
            await this.props.postMountCallback();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        // if( !_.isEqual(this.props.selectedItems, prevProps.selectedItems))
        //     this.setState({selected:this.props.selectedItems ? this.props.selectedItems : []})

        if( !_.isEqual(this.props.assessmentInfo, prevProps.assessmentInfo))
             this.setState({selected:this.props.assessmentInfo ? this.props.assessmentInfo : {}})
    }


    render() {


        console.log("ASSESSMENT INFO: " + this.props.assessmentInfo);

        let frm =
            <Form>
                <Form.Group className="mb-3" controlId="assessmentPurpose">
                    <Form.Label>Assessment Purpose</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={4}
                        placeholder="Enter query purpose here."
                        value={this.state.assessmentInfo.purpose}
                        // onChange={(e) => this.setState({ assessmentPurpose: e.target.value })}
                        onChange={(e) => this.handleAssessmentPurposeChange(e.target.value, this.props.updateConfig)}
                    />
                </Form.Group>

                <Form.Group className="mb-3" controlId="employeeInitials">
                    <Form.Label>Employee Initials</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Type your initials here."
                        value={this.state.assessmentInfo.employeeInitials}
                        //onChange={(e) => this.setState({ employeeInitials: e.target.value })}
                        onChange={(e) => this.handleAssessmentEmployeeInitialsChange(e.target.value, this.props.updateConfig)}
                    />
                </Form.Group>
            </Form>




        return (

            <div>

                    <NavPanel title="New Assessment" content={frm} prev={this.props.prev}
                              next={(this.state.assessmentInfo.purpose?.trim() && this.state.assessmentInfo.employeeInitials?.trim()) ? this.props.next : null}
                    />

            </div>

        );
    }


    handleAssessmentPurposeChange(newPurpose, updateConfig) {

        console.log("handleChange(): " + newPurpose);

        let newAssessmentInfo = {purpose: newPurpose, employeeInitials: this.state.assessmentInfo.employeeInitials};

        if(updateConfig)
        {
            updateConfig(newAssessmentInfo);
        }

        this.setState(
            {
                assessmentInfo: newAssessmentInfo
            }
        );

    }

    handleAssessmentEmployeeInitialsChange(newEmployeeInitials, updateConfig) {

        console.log("handleChange(): " + newEmployeeInitials);

        let newAssessmentInfo = {purpose: this.state.assessmentInfo.purpose, employeeInitials: newEmployeeInitials};

        if(updateConfig)
        {
            updateConfig(newAssessmentInfo);
        }

        this.setState(
            {
                assessmentInfo: newAssessmentInfo
            }
        );

    }


}


NewAssessment.propTypes = NewAssessmentPropTypes;

export default NewAssessment;
